import { Alert, Button, Group, Text } from '@mantine/core';
import { IconSparkles } from '@tabler/icons-react';
import { useNavigate } from '@tanstack/react-router';

interface TrialUpgradeBannerProps {
  planName: string;
}

export function TrialUpgradeBanner({ planName }: TrialUpgradeBannerProps) {
  const navigate = useNavigate();

  return (
    <Alert
      variant="light"
      color="blue"
      icon={<IconSparkles size={20} />}
      title="Trial Plan"
    >
      <Group justify="space-between" align="center">
        <Text size="sm">
          You are currently on the <Text span fw={600}>{planName}</Text> trial plan.
          Upgrade to unlock all features and avoid service interruption.
        </Text>
        <Button
          variant="filled"
          size="sm"
          onClick={() => navigate({ to: '/account/upgrade-trial' })}
        >
          Upgrade Now
        </Button>
      </Group>
    </Alert>
  );
}
